export function padWithZeros(input, totalLength) {
    return input.toString().padStart(totalLength, '0');
}

export function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function truncateText(text, maxLength) {
    if (text.length > maxLength) {
        return `${text.substring(0, maxLength)}...`;
    }
    return text;
};


export function formatString(input, formatType) {
    if (typeof input !== 'number' || input.toString().length !== 10) {
        return ''; // Retorna vazio se o input não for um número com 10 dígitos
    }

    const inputString = input.toString();
    const year = inputString.slice(0, 4); // Os primeiros 4 caracteres são o ano
    const sequence = inputString.slice(4); // Os 6 caracteres restantes são a sequência

    switch (formatType) {
        case 1: // Formato "000001-2024"
            return `${sequence}-${year}`;
        case 2: // Formato "000001/2024"
            return `${sequence}/${year}`;
        case 3: // Formato "001-2024"
            return `${parseInt(sequence, 10).toString().padStart(3, '0')}-${year}`;
        case 4: // Formato "001/2024"
            return `${parseInt(sequence, 10).toString().padStart(3, '0')}/${year}`;
        default:
            return ''; // Retorna vazio para formatos inválidos
    }
}


